export default __webpack_public_path__ + "static/media/cockpit-Header-4k.cf708eca.jpg";